import { useSearchParams } from 'react-router'

import { EMPTY_OBJECT, EMPTY_STRING } from '../../../../constants/common'
import { ARCHIVED_FILTER_NAME } from '../../../../constants/filter'
import { SEARCH_RESULTS_QUERY_PARAM_KEY } from '../../../../constants/route'

export function useSearchResultsParams({
  queryParamKey = SEARCH_RESULTS_QUERY_PARAM_KEY,
} = EMPTY_OBJECT) {
  const [searchParams] = useSearchParams()

  const searchQuery = searchParams.get(queryParamKey) || EMPTY_STRING

  const isArchived = searchParams.get(ARCHIVED_FILTER_NAME) === 'true'

  return { isArchived, searchQuery }
}
